export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11741.45df7c68.jpg";